import { toSocialCurrency } from '@/utils/numeric/currency';
import { TFunction } from 'i18next';

export type PackageRewardKind = 'bonus' | 'profit_boost' | 'no_sweat' | 'mystery_gift';

export type PackageReward = {
    id: string;
    kind: PackageRewardKind;
    label: string;
};

type PackageRewardConfig = {
    kind: PackageRewardKind;
    amount: number;
};

type PackagePromoConfig = {
    mostPopular: number[];
    /** Rewards per `coin_package_id`, in display order. */
    rewards: Record<number, PackageRewardConfig[]>;
};

type SweepsTFunction = TFunction<['common', 'wallet', 'sweeps'], undefined>;

// One label per reward kind; the amount is data, not part of the reward's identity.
const REWARD_LABELS: Record<PackageRewardKind, (t: SweepsTFunction, amount: number) => string> = {
    bonus: (t, amount) => t('sweeps:reward_bonus_up_to', { amount: toSocialCurrency(amount) }),
    profit_boost: (t, count) => t('sweeps:reward_profit_boosts', { count }),
    no_sweat: (t, count) => t('sweeps:reward_no_sweats', { count }),
    mystery_gift: (t, count) => t('sweeps:reward_mystery_gifts', { count }),
};

// TODO: Replace with data from the bonus engine when ready, including the definitive list of reward kinds.
export const PACKAGE_PROMO_CONFIG: PackagePromoConfig = {
    mostPopular: [],
    rewards: {},
};

export const isMostPopularPackage = (packageId: number) => PACKAGE_PROMO_CONFIG.mostPopular.includes(packageId);

export const getPackageRewards = (packageId: number, t: SweepsTFunction): PackageReward[] =>
    (PACKAGE_PROMO_CONFIG.rewards[packageId] ?? []).map(({ kind, amount }) => ({
        id: `${kind}_${amount}`,
        kind,
        label: REWARD_LABELS[kind](t, amount),
    }));
